import { useCallback, useMemo } from 'react'
import { Users } from 'lucide-react'
import { useT } from '@/i18n'
import { DataTable } from '@/components/DataTable'
import type { AdminColumn } from '@/components/DataTable/types'
import { fetchStaffActivity, type StaffActivityRow } from '@/lib/adapters'
import { PERMISSIONS } from '@/lib/permissions'

/**
 * A18.04 — Xodim faoliyati. `/admin/audit` oynasini (server cap 200) xodim
 * bo'yicha agregatlaydi: amal soni + oxirgi amal/vaqt/IP. Butun tarix EMAS —
 * oxirgi 200 audit yozuvi (banner bilan halol belgilangan). SecurityScreen tab-i
 * (o'z PageHeader'i yo'q — umumiy A18 sarlavhasi ostida).
 */
export function StaffActivity() {
  const t = useT()

  const columns = useMemo<AdminColumn<StaffActivityRow>[]>(
    () => [
      { key: 'admin', header: t.col.staff, type: 'text', minWidth: 160 },
      {
        key: 'actions',
        header: t.security.actionCount,
        type: 'number',
        width: 110,
        align: 'right',
        render: (r) => <span className="font-mono tabular">{r.actions.toLocaleString()}</span>,
      },
      { key: 'last_action', header: t.col.action, type: 'text', width: 180 },
      { key: 'last_at', header: t.col.time, type: 'date', width: 160 },
      { key: 'last_ip', header: t.col.ip, type: 'text', width: 140, hiddenByDefault: true },
    ],
    [t],
  )

  const fetcher = useCallback(fetchStaffActivity, [])

  return (
    <div className="flex min-h-0 flex-1 flex-col">
      <div className="border-b border-border-subtle px-3 py-1.5 text-xs text-tertiary">
        {t.security.auditWindowNote}
      </div>
      <DataTable<StaffActivityRow>
        screenId="A18.04"
        permission={PERMISSIONS.AUDIT_VIEW}
        columns={columns}
        fetcher={fetcher}
        rowId={(r) => r.admin}
        exportable
        emptyState={{ icon: <Users size={28} strokeWidth={1.5} /> }}
      />
    </div>
  )
}
